import React from "react";
import { observer } from "mobx-react";
import "primeflex/primeflex.css";
import { GoalsViewModel } from "./GoalsViewModel";
import Utils from "../../infrastructure/Utils";
import { Permission } from "../../infrastructure/enum/Permission";
import { Card } from "primereact/card";
import { IMASMessagesHandler } from "../components/controls/IMASMessagesHandler";

export const GoalsView: React.FC<{
  vm: GoalsViewModel;
}> = observer(() => {
  let env = Utils.getAppHostKey();
  let goalsUrl =
    `https://bonus-${env}.integrityconnect.com/app?tenantName=${Utils.getBUName()}`.replace(
      "-prod",
      ""
    );

  return (
    <>
      {Utils.hasUserPermission(Permission.ViewGoalsRecords) ? (
        <div className="goals-container">
          <iframe
            src={`${goalsUrl}`}
            id="goals-iframe"
            frameBorder="0"
            style={{ height: "calc(100vh - 70px)", width: "100%" }}
          />
        </div>
      ) : (
        <Card>
          <IMASMessagesHandler response={Utils.errorMsg()} />
        </Card>
      )}
    </>
  );
});
